
let mCardlinkCache:any;
export function initCardlinkCache(db:any){
    mCardlinkCache = db.table('cardLinkCache');
}

export function updatecardlinkCache(cardLink:any){
    mCardlinkCache.put(cardLink);
}

export function getCardlinkCacheById(id:any){
    return mCardlinkCache.get(id);
}